<template>
  <header class="header">

      <nav class="header__menu">
        <ul class="nav">
          <li><a href="https://blesk.cz/o-nas">O nás</a></li>
          <li><a href="https://blesk.cz/souteze">Soutěže</a></li>
          <li><a href="https://blesk.cz/kontakt">Kontakt</a></li>
        </ul>
      </nav>

      <a class="header__logo" href="https://www.blesk.cz" title="Blesk.cz" aria-label="Přejít na blesk.cz" role="banner" >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 70 24" height="24" width="70" fill="none"><path fill="#ffffff" fill-rule="evenodd" d="M18.333 6.708C19.143 1.62 15.035 0 11.276 0H3.76L0 23.595h8.617c5.667 0 8.038-3.817 8.501-6.766.52-3.123-.81-5.09-3.932-5.32v-.058c2.66 0 4.742-2.024 5.147-4.743M9.947 5.09c1.33 0 2.198.636 1.966 2.024-.231 1.562-1.503 2.082-2.891 2.024h-.347L9.31 5.09zm-1.504 8.906c1.446 0 2.545.636 2.314 2.256-.232 1.561-1.562 2.255-3.008 2.255h-.52l.694-4.51zM52.626 3.181 51.586 9.6c-.521-1.041-1.678-2.255-3.008-2.255-.694 0-1.561.462-1.677 1.272-.058.463.116.867.347 1.156.198.297.523.552.794.764q.069.053.131.104c1.041.81 1.909 1.62 2.43 2.602.52.983.693 2.082.462 3.702C50.429 20.877 47.19 24 43.2 24c-1.446 0-2.892-.29-4.164-.867l.694-4.396.347-2.255c.636 1.157 1.793 2.371 3.239 2.371.81 0 1.792-.463 1.908-1.388.116-.52 0-.867-.29-1.157-.173-.289-.462-.578-.809-.81-.983-.867-1.85-1.676-2.429-2.717-.52-.983-.81-2.14-.578-3.701.058-.405.173-.81.347-1.273.867-2.487 3.123-5.667 7.229-5.667a6.9 6.9 0 0 1 3.932 1.04m5.842 10.699h-.058l-1.504 9.715h-5.783L54.477 2.43h5.725l-1.387 9.022h.057l4.511-9.022h6.015l-6.13 10.236 3.354 10.93h-6.13zM40.77 7.46l.752-5.031h-10.64l-3.354 21.166h10.64l.81-4.973h-4.915l.52-3.239h4.395l.81-4.973h-4.395l.462-2.95zm-13.3 11.162-.81 4.973H16.656L20.01 2.43h5.725l-2.602 16.193z" clip-rule="evenodd"></path></svg>
      </a>

      <div class="header__actions">
        <!--<button class="button button&#45;&#45;primary">
          Přihlásit se
        </button>-->
      </div>
  </header>
</template>

<script setup lang="ts">
</script>
